// components/FullPageLoader.tsx
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import logo from './assets/logo.png';
// import { Atom } from 'react-loading-indicators';

const FullPageLoader: React.FC = () => {
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 64, color: 'rgb(99, 106, 232)' }} spin />
  );
  
  return (
    <div style={styles.overlay}>
      <div style={styles.inner}>
        <img
          src={logo}
          alt="Logo"
          style={styles.logo}
        />
        {/* <Atom color="#47a3da" size="large" text="Loading..." textColor="" /> */}
        <Spin indicator={antIcon} />
        <div style={styles.message}>Loading, please wait...</div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#fff',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    animation: 'fadeIn 0.5s ease-in-out',
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
  },
  logo: {
    width: 100,
    height: 100,
    objectFit: 'contain',
    marginBottom: 10,
  },
  message: {
    fontSize: 16,
    color: '#666',
    fontWeight: 400,
    letterSpacing: 0.5,
  },
};

export default FullPageLoader;
